import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultSubmitEvents = {
    onSettingsChange: noop,
    onClick: noop
};

function useSubmitEvents(props) {
    const {
        submitEvents: propsSubmitEvents
    } = props;

    const {
        events: submitEvents
    } = useEvents(defaultSubmitEvents, propsSubmitEvents);

    const result = {
        submitEvents
    };

    useDebugValue(result);

    return result;
}

export {useSubmitEvents};
